<template>
    <Modal size="md" @close="close">
        <div class="text-center text-sm p-10 px-4 sm:px-12">
            <div class="TopIconModal text-purple-500 text-6xl m-b-lg">
                <i class="fa fa-rss"></i>
            </div>
            <h2 class="font-semibold m-b-lg">
                Content Radar System
            </h2>
            <p class="m-b-lg">
                Indsamler automatisk influentens posts og stories, som indeholder din virksomheds
                Instragram @tag eller #hashtags. Alle tags skal være komma separeret. <br /><br />
            </p>
            <p class="alert alert-info">
                Vær opmærksom på at en opdatering scanner alt influentens tidligere content og det
                kan tage op til flere minutter. Content der allerede er indsamlet vil ikke blive
                påvirket.
            </p>

            <form @submit.prevent="update">
                <div class="input-group input-group w-full m-b-lg">
                    <label class="block text-left">Instagram @tag og #hashtags</label>
                    <input
                        v-model="form.ambassador_keywords"
                        type="text"
                        class="rounded-sm form-control"
                        :placeholder="'@' + brand.name + ', #' + brand.name"
                    />
                </div>
                <button type="submit" class="btn btn-primary p-4 px-8" :disabled="form.busy">
                    Opdater
                </button>
            </form>
        </div>
    </Modal>
</template>

<style lang="less" type="text/less"></style>

<script type="text/babel">
import Modal from 'dashboard-js/components/Modal'

export default {
    components: { Modal },

    props: ['brand'],

    data() {
        return {
            form: new SparkForm({
                ambassador_keywords: this.brand.ambassador_keywords,
            }),
        }
    },

    methods: {
        update() {
            Spark.sendFormData('put', route('api.brand.update', this.brand.id), this.form).then(
                response => {
                    this.$emit('updated', response.data)
                    this.close()
                }
            )
        },

        close() {
            this.$emit('close')
        },
    },
}
</script>
